import { Button, TextField } from '@mui/material';
import { FC, useState } from 'react';

import { FutureParker } from '../../../types';

type FutureParkerEditorProps = {
	parker: FutureParker;
	loading: boolean;
	updateSequenceNumber: (parker: FutureParker, sequenceNumber: number) => Promise<void>;
};

export const FutureParkerEditor: FC<FutureParkerEditorProps> = ({ parker, loading, updateSequenceNumber }) => {
	const [editMode, setEditMode] = useState<boolean>(false);
	const [sequenceNumber, setSequenceNumber] = useState<number>(parker.sequenceNumber);

	return editMode ? (
		<>
			<TextField
				sx={{ minWidth: '50px', maxWidth: '50px' }}
				size='small'
				type='number'
				value={sequenceNumber}
				onChange={(e) => setSequenceNumber(Number(e.target.value))}
				onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
			/>
			<Button
				variant='outlined'
				size='small'
				sx={{ marginLeft: '15px' }}
				onClick={() => {
					setSequenceNumber(parker.sequenceNumber);
					setEditMode(false);
				}}
			>
				Cancel
			</Button>
			<Button
				variant='contained'
				size='small'
				sx={{ marginLeft: '15px' }}
				onClick={() => {
					updateSequenceNumber(parker, sequenceNumber);
					setEditMode(false);
				}}
			>
				Save
			</Button>
		</>
	) : (
		<>
			<Button
				variant='contained'
				size='small'
				disabled={loading}
				sx={{ marginRight: '15px' }}
				onClick={() => setEditMode(true)}
			>
				Edit
			</Button>
			<span>{sequenceNumber}</span>
		</>
	);
};
